import { ReactComponent as Logo } from "../../vendor/logo_white.svg";
import Footer from "./SidebarFooter";
import SidebarMobileAccountSection from "./SidebarMobileAccountSection";
import SidebarNav from "./SidebarNav";
import { regularUserNavConfig, superuserNavConfig } from "./navConfig";
import {
  ListItemButton,
  Drawer as MuiDrawer,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useAuth from "hooks/useAuth";
import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components/macro";

const Drawer = styled(MuiDrawer)`
  border-right: 0;

  > div {
    border-right: 0;
  }
`;

const Brand = styled(ListItemButton)`
  font-size: ${(props) => props.theme.typography.h5.fontSize};
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
  color: ${(props) => props.theme.palette.sidebar.headerColor};
  background-color: ${(props) => props.theme.palette.sidebar.headerBackground};
  font-family: ${(props) => props.theme.typography.fontFamily};
  height: 228px;
  padding-left: ${(props) => props.theme.spacing(6)};
  padding-right: ${(props) => props.theme.spacing(6)};
  justify-content: center;
  cursor: pointer;
  flex-grow: 0;
  border-right: 1px solid ${(props) => props.theme.palette.sidebar.border};

  ${(props) => props.theme.breakpoints.up("sm")} {
    height: 228px;
  }

  &:hover {
    background-color: ${(props) =>
      props.theme.palette.sidebar.headerBackground};
  }
`;

const BrandIcon = styled(Logo)`
  margin-right: ${(props) => props.theme.spacing(2)};
  color: ${(props) => props.theme.palette.sidebar.brandColor};
  fill: ${(props) => props.theme.palette.sidebar.brandColor};
  width: 80%;
`;

const DrawerContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const NavContainer = styled.div`
  flex: 1;
  min-height: 0;
`;

const Sidebar = ({ showFooter = false, ...rest }) => {
  const user = useAuth();
  const theme = useTheme();
  const isPhone = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Drawer {...rest}>
      <DrawerContent>
        <Brand component={NavLink} to="/">
          <BrandIcon />
        </Brand>
        <NavContainer>
          <SidebarNav
            navConfig={
              user.isSuperuser ? superuserNavConfig : regularUserNavConfig
            }
          />
        </NavContainer>
        {isPhone && <SidebarMobileAccountSection />}
        {!!showFooter && !isPhone && <Footer />}
      </DrawerContent>
    </Drawer>
  );
};

export default Sidebar;
